<template>
  <slot></slot>
  <Toast />
</template>

<script setup lang="ts">
import Toast from '@/components/Toast/Index.vue';
</script>
